import React from 'react';
import { node } from 'prop-types';

import './panel.scss';

const Panel = ({ children }) => (
    <div className="panel">
        {children}
    </div>
);

Panel.propTypes = {
    children: node.isRequired
};

export default Panel;
